import { useLocation } from 'react-router-dom';
import Path from 'routes/path';

export default function useHistoryPath() {
  const { pathname } = useLocation();

  return { isHistoryPath: !!pathname.match(Path.history) };
}
